import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import useSeo from "../hooks/useSeo";
import { seoTitle, seoDescription } from "../lib/seoTitle";
import api from "../lib/api";
import { RelatedProducts } from "../components/RelatedProducts";
import { NewsletterForm } from "../components/NewsletterForm";
import ShareButtons from "../components/ShareButtons";

export default function GuidePage() {
  const { slug } = useParams();
  const [guide, setGuide] = useState(null);
  useEffect(() => { api.get("/content").then(({ data }) => setGuide(data.guide)).catch(() => {}); }, []);
  const articles = guide?.articles || [];
  const article = slug ? articles.find((a) => a.slug === slug) : null;
  useSeo(guide ? (article
    ? { title: seoTitle(article.title), description: seoDescription(article.excerpt, article.title), path: `/guida/${article.slug}`,
        jsonLd: [{ "@context": "https://schema.org", "@type": "Article", headline: article.title, description: seoDescription(article.excerpt, article.title), author: { "@type": "Organization", name: "Guatemalan Spirits" } }] }
    : { title: seoTitle(guide.title), description: seoDescription(guide.intro, guide.title), path: "/guida", jsonLd: [] }) : {});

  return (
    <div className="min-h-screen bg-[#FAFAF7] paper-grain" data-testid="guide-page">
      <Navbar />
      <section className="max-w-4xl mx-auto px-6 py-12">
        {slug && guide && !article && <div data-testid="guide-not-found"><h1 className="font-serif text-3xl text-[#0B2A45] mb-3">Articolo non trovato</h1><Link to="/guida" className="text-[#0F4C81] underline">Torna alla guida</Link></div>}
        {article ? (
          <article data-testid="guide-article">
            <Link to="/guida" className="text-xs text-stone-400 hover:underline">← Tutti gli articoli</Link>
            <h1 className="font-serif text-4xl sm:text-5xl font-bold text-[#0B2A45] mt-3 mb-6">{article.title}</h1>
            <p className="text-lg text-stone-500 mb-6">{article.excerpt}</p>
            <div className="prose prose-stone max-w-none text-stone-700 leading-relaxed whitespace-pre-line">{article.body}</div>
            <RelatedProducts slug={article.slug} />
            <div className="mt-10"><ShareButtons title={article.title} url={`https://guatemalanspirit.it/guida/${article.slug}`} /></div>
            <NewsletterForm source={`guida/${article.slug}`} />
          </article>
        ) : guide && !slug && (
          <>
            <div className="text-[0.7rem] uppercase tracking-[0.2em] font-semibold text-[#C2593F] mb-2 flex items-center gap-2"><BookOpen className="w-4 h-4" />{guide.eyebrow}</div>
            <h1 className="font-serif text-4xl sm:text-5xl font-bold text-[#0B2A45] mb-4">{guide.title}</h1>
            <p className="text-stone-600 max-w-2xl mb-10">{guide.intro}</p>
            <div className="grid sm:grid-cols-2 gap-5">
              {articles.map((a) => (
                <Link key={a.slug} to={`/guida/${a.slug}`} className="block bg-white rounded-2xl border border-stone-200 p-6 hover:shadow-lg hover:-translate-y-0.5 transition-[transform,box-shadow]" data-testid={`guide-card-${a.slug}`}>
                  <h2 className="font-serif text-lg font-semibold text-[#0B2A45] mb-2">{a.title}</h2>
                  <p className="text-sm text-stone-500 mb-3">{a.excerpt}</p>
                  <span className="text-sm font-semibold text-[#C2593F] inline-flex items-center gap-1">Leggi <ArrowRight className="w-4 h-4" /></span>
                </Link>
              ))}
            </div>
          </>
        )}
      </section>
      <Footer />
    </div>
  );
}
